import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonColor, ButtonSize } from '@infocert/ng-ui-kit/models';

@Component({
    selector: 'app-submit-button',
    templateUrl: './submit-button.component.html',
    styleUrls: ['./submit-button.component.scss'],
    standalone: false
})
export class SubmitButtonComponent {
  constructor() {}
  @Input() color: ButtonColor = 'primary';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() label: string = 'label';
  @Input() class: string = '';
  @Input() iconAfter: string = '';
  @Input() size: ButtonSize = 'sm';
  @Input() translateKey: string = '';
  @Input() type: 'button' | 'submit' = 'button';
  @Input() stopPropagation = true;

  @Output() onClick: EventEmitter<boolean> = new EventEmitter();

  get classes(): string {
    return `${this.class} ${this.loading ? 'loading' : ''}`;
  }

  handleOnClick() {
    this.onClick && this.onClick.emit(true);
  }
}
